import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { MatStepper } from "@angular/material/stepper";
import { TrainsInfo } from "@core/models/trainsInfo";
import { TrainService } from "@core/services";
import moment from "moment";

@Component({
  selector: "app-train-passenger-form",
  templateUrl: "./train-passenger-form.component.html",
  styleUrls: ["./train-passenger-form.component.scss"],
})
export class TrainPassengerFormComponent implements OnInit {
  @Input() stepper: MatStepper;
  trainsInfo: TrainsInfo;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    public trainService: TrainService
  ) {
    this.trainService.getTrainsInfo$().subscribe((info: TrainsInfo) => {
      this.trainsInfo = info;
    });
  }

  ngOnInit(): void {
    this.createFormAndPreFill();
  }

  createFormAndPreFill() {
    this.trainsInfo.travellersForm = this._formBuilder.array([]);
    this.trainsInfo.travellers.forEach((user) => {
      const birthdate = moment(user.birthdate.split("T")[0]).format("YYYY-MM-DD");
      const group = this._formBuilder.group({
        name: [
          user.name || "",
          [Validators.required, Validators.maxLength(90), Validators.minLength(2)],
        ],
        surname: [
          user.lastname ? user.lastname.split(" ")[0] : "",
          [Validators.required, Validators.maxLength(90)],
        ],
        lastSurname: [
          user.lastname ? user.lastname.split(" ")[1] : "",
          [Validators.maxLength(90)],
        ],
        email: [user.email || "", [Validators.maxLength(90)]],
        birthdate: [
          user.birthdate
            ? {
                year: +birthdate.split("-")[0],
                month: +birthdate.split("-")[1],
                day: +birthdate.split("-")[2],
              }
            : "",
          [Validators.required],
        ],
        phone: [user.phone || "", [Validators.required]],

        documentType: [
          user.dni ? "DNI" : user.passport ? "PASSPORT" : user.nie ? "NIE" : "",
          [Validators.required],
        ],

        documentNumber: [
          user.dni || user.passport || user.nie || "",
          [Validators.required],
        ],

        uuid: [user?.uuid || ""],
        departmentUuid: [user?.departmentUuid || ""],
      });
      group.get('documentType')!.valueChanges.subscribe(type => {
        const docControl = group.get('documentNumber');

        if (type === 'DNI') {
          docControl?.setValue(user.dni || '');
        }

        if (type === 'NIE') {
          docControl?.setValue(user.nie || '');
        }

        if (type === 'PASSPORT') {
          docControl?.setValue(user.passport || '');
        }
      });
      this.trainsInfo.travellersForm.push(group);
    });
  }

  goNextStep() {
    this.stepper.next();
  }
}
